import useAccountsControllerState from './useAccountsControllerState'

export default useAccountsControllerState
